/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetSlackCardNotificationSettings200ResponseInnerUserAccountGroupsInner } from './get-slack-card-notification-settings200-response-inner-user-account-groups-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner } from './get-slack-card-notification-settings200-response-inner-user-accounts-inner';

/**
 * 
 * @export
 * @interface GetSlackCardNotificationSettings200ResponseInner
 */
export interface GetSlackCardNotificationSettings200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInner
     */
    'channelId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSlackCardNotificationSettings200ResponseInner
     */
    'transactionTypes': Array<GetSlackCardNotificationSettings200ResponseInnerTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInner
     */
    'largeAmountThreshold': number | null;
    /**
     * 
     * @type {Array<GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner>}
     * @memberof GetSlackCardNotificationSettings200ResponseInner
     */
    'userAccounts': Array<GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner>;
    /**
     * 
     * @type {Array<GetSlackCardNotificationSettings200ResponseInnerUserAccountGroupsInner>}
     * @memberof GetSlackCardNotificationSettings200ResponseInner
     */
    'userAccountGroups': Array<GetSlackCardNotificationSettings200ResponseInnerUserAccountGroupsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInner
     */
    'isAllUserAccount': boolean;
}

export const GetSlackCardNotificationSettings200ResponseInnerTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type GetSlackCardNotificationSettings200ResponseInnerTransactionTypesEnum = typeof GetSlackCardNotificationSettings200ResponseInnerTransactionTypesEnum[keyof typeof GetSlackCardNotificationSettings200ResponseInnerTransactionTypesEnum];


